<template>
   <v-app id="inspire">
      <v-content>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12" style="background-color:#040021;">
                     <v-toolbar dark color="white">
                        <v-toolbar-title style="color: #1908cc" class="title text-center">{{text.question['ca']}}</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text color="white" class="text-center">
                        <v-form color="white" class="text-center">
                           <v-text-field
                              name="login"
                              label=""
                              type="text"
                              v-model="inputText"
                              color="white" 
                              
                           ></v-text-field>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- :disabled="!connected || inputText.length < 4" -->
                        <v-btn  
                           elevation="20"
                           style="color: #ffffff; background-color:#1c06d3; font-weight: bold;"  
                           class="pl-7 pr-7 rounded-pill text-no-wrap"                      
                           v-on:click="sendText()">{{sendTag}}</v-btn>
                        <v-spacer></v-spacer>
                     </v-card-actions>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-content>
   </v-app>
</template>

<script>
/* eslint-disable */
import HelloWorld from './components/HelloWorld';
import  mqtt from 'mqtt/dist/mqtt';

export default {
  name: 'App',

  components: {    
  },

  mounted(){
    console.log("I'm mounted")
    this.mqttClient = mqtt.connect('wss://mqtt2.iglor.es:10443/mqtt')
    this.mqttClient.on('connect',this.onConnect)
    this.inputText = ''
  },

  data: () => ({
    mqttClient: null,
    connected: false,
    inputText: '',
    sendTag: 'SEND',
    sended: false,
    text:{
      question: {
         en: "What is the meaning of love for you?",
         es: "¿Qué es para ti el amor?",
         ca: "Què és per a tu l'amor?"
      },

    },
  }),
  methods:{
    onConnect(){
      console.log("mqtt connected")
      this.connected = true
    },
    sendText(){
      if( !this.sended ){
         this.mqttClient.publish('touchdesigner',this.inputText)
         this.sendTag="RECEIVED"
         this.sended = true
         console.log("published")
      }
         
    }
  }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=VT323');
html, body {
    font-family: 'VT323' !important;
    font-size: x-large;
    font-weight: bold;
}
.v-input input, .v-input textarea {
    color: rgb(255 255 255 / 87%) !important;
}
.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: rgba(255, 255, 255, 1) !important;
}
.v-application{
    font-family: "VT323" !important;
    line-height: 1.5;
    background-image: url(https://k2tmp.s3.eu-west-3.amazonaws.com/120/Fondo_Text_Collector.jpg) !important;
}

.v-application .title{
    font-family: "VT323" !important;
    line-height: 1.5;
}

.v-application .elevation-20 {
box-shadow: 3px 3px 2px -1px rgba(255,255,255,0.74) !important;
}

.v-toolbar__title {
   white-space:  break-spaces;
   
}

.v-sheet.v-toolbar, .v-toolbar__content{ 
   height: 80px !important;
}
</style>